import Axios from 'axios'
import { getToken } from './adalConfig';

const located = window.location;
const apiUrl = `${located.protocol}//${located.hostname}${(located.port ? ':' + located.port : '')}/api/`;

const stHeaders = {
    //"Access-Control-Allow-Origin": "*",
    //"Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization,Accept-Encoding"
};

const HTTP = createAxios();

function createAxios() {
    const headers = { ...stHeaders };
    headers.Accept = "application/json";
    headers.Authorization = `Bearer ${getToken()}`;

    const axios = Axios.create({
        headers: headers,
        baseURL: apiUrl
    });

    axios.interceptors.request.use(
        conf => {
            return conf;
        },
        error => {
            return Promise.reject(error);
        }
    );
    axios.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (error.response && error.response.status && (error.response.status === 401 || error.response.status === 403)) {
                window.location.replace("/noaccess");
            }
            return Promise.reject(error);
        }
    );
    return axios;
}

export default {

    getLots: (query) => {
        return HTTP.get(`SaleDisplay/GetLots${query ? "?" + query : ""}`);
    },
    getTotals: (query) => {
        return HTTP.get(`SaleDisplay/GetLotTotals${query ? "?" + query : ""}`);
    },
    getSaleDisplayType: (query) => {
        return HTTP.get(`lpb/GetSaleDisplayType${query ? "?" + query : ""}`);
    },

    // LPB Entry
    saveTransaction: (query) => {
        return HTTP.get(`lpb/SaveTransaction${query ? "?" + query : ""}`); 
    },

    //manual lot transfer
    processLotsForManualTransfer: (query) => {
        return HTTP.get(`lpb/ProcessLotsForManualTransfer${query ? "?" + query : ""}`);
    },

    //finalise sale
    finaliseSale: (query) => {
        return HTTP.get(`lpb/FinaliseSale${query ? "?" + query : ""}`);
    },
    completeSale: (query) => {
        return HTTP.get(`lpb/CompleteSale${query ? "?" + query : ""}`);
    },
    checkAccess: (query) => {
        return HTTP.get(`lpb/CheckAccess`);
    },
    //check data lock
    hasSaleDateExpired: (query) => {
        return HTTP.get(`lpb/HasSaleDateExpired${query ? "?" + query : ""}`);
    },
    //get default sale id (if any)
    getCurrentSaleIdForUser: (query) => {
        return HTTP.get(`lpb/GetCurrentSaleIdForUser${query ? "?" + query : ""}`);
    },
}